import * as bulmaToast from 'bulma-toast'

export function errorToast(msg) {
  const toast = bulmaToast.toast({
    duration: 5000,
    offsetTop: '50px',
    position: 'top-right',
    closeOnClick: false,  // ไม่ให้หายเมื่อคลิกที่ Toast ตัวเอง
    opacity: 0.9,
    type: 'is-danger',
    message: msg,
    dismissible: true
  })

  // // เพิ่ม event listener เพื่อปิด Toast เมื่อคลิกที่ x
  // toast.toastElement.addEventListener('click', () => {
  //   bulmaToast.dismiss(toast)
  // })
}

export function successToast(msg) {
  const toast = bulmaToast.toast({
    duration: 5000,
    offsetTop: '50px',
    position: 'top-right',
    closeOnClick: false,  // ไม่ให้หายเมื่อคลิกที่ Toast ตัวเอง
    opacity: 0.9,
    type: 'is-success',
    message: msg,
    dismissible: true
  })

  // // เพิ่ม event listener เพื่อปิด Toast เมื่อคลิกที่ x
  // toast.toastElement.addEventListener('click', () => {
  //   bulmaToast.dismiss(toast)
  // })
}
